import React from "react";
import {
  Typography,
  Grid,
  TextField,
  InputAdornment,
  Avatar,
  Box,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const inputStyles = {
  borderRadius: "50px",
  boxShadow: "0.5px 3px 10px 0px #7777771A",
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "50px",
    borderColor: "#ccc",
  },
  "& .MuiInputBase-input": {
    color: "#6A707E",
    fontSize: "16px",
    fontWeight: 600,
  },
  "& .MuiInputBase-input::placeholder": {
    color: "#6A707E",
  },
  "& .MuiInputLabel-root": {
    color: "#6A707E",
    fontSize: "16px",
    fontWeight: 600,
  },
};

const PlayerFormFields = ({ editedPlayer, handleInputChange }) => {
  const dropdownAdornment = (
    <InputAdornment position="end">
      <KeyboardArrowDownIcon />
    </InputAdornment>
  );

  return (
    <Box sx={{ flex: 1 }}>
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            Name
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="name"
            value={editedPlayer.name}
            onChange={handleInputChange}
            sx={inputStyles}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            Nickname
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="nickname"
            value={editedPlayer.nickname}
            onChange={handleInputChange}
            sx={inputStyles}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            Number
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="number"
            value={editedPlayer.number}
            onChange={handleInputChange}
            sx={inputStyles}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">#</InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            Position
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="position"
            value={editedPlayer.position}
            onChange={handleInputChange}
            InputProps={{ endAdornment: dropdownAdornment }}
            sx={inputStyles}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            Sport
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="sport"
            value={editedPlayer.sport}
            onChange={handleInputChange}
            InputProps={{ endAdornment: dropdownAdornment }}
            sx={inputStyles}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            League
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="league"
            value={editedPlayer.league}
            onChange={handleInputChange}
            InputProps={{ endAdornment: dropdownAdornment }}
            sx={inputStyles}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            Team
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="team"
            value={editedPlayer.team}
            onChange={handleInputChange}
            InputProps={{ endAdornment: dropdownAdornment }}
            sx={inputStyles}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            Feed ID
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="id"
            value={editedPlayer.id}
            onChange={handleInputChange}
            sx={inputStyles}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            Nationality
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="nationality"
            value={editedPlayer.nationality}
            onChange={handleInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Avatar
                    src={editedPlayer.nationalityFlag}
                    alt={editedPlayer.nationality}
                    sx={{ width: 24, height: 24 }}
                  />
                </InputAdornment>
              ),
              endAdornment: dropdownAdornment,
            }}
            sx={inputStyles}
          />
        </Grid>

        <Grid item xs={4}>
          <Typography
            sx={{ color: "#464A53", fontSize: "16px", fontWeight: 600 }}
          >
            Injury Status
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <TextField
            fullWidth
            name="injuryStatus"
            value={editedPlayer.injuryStatus}
            onChange={handleInputChange}
            InputProps={{ endAdornment: dropdownAdornment }}
            sx={inputStyles}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PlayerFormFields;
